import React from 'react';

import { connect } from 'react-redux';

import Table from './'

const mapStateToProps = (state) => ({
    selections: state.selections
})

function TableController(props = {}) {
    return (
        <Table {...props}/>
    )
}

export default connect(mapStateToProps)(TableController);